import qs from 'query-string';
import { maxImageRatio, sizeRatioMap } from './constants';

// Types
import type { ImageSize } from '$lib/types/Components/SharedTypes';

export const getHostname = (url: string) => new URL(url).hostname;

export const getParamsFromUrl = (url: string): { [key: string]: string } | undefined => {
    if (!url) return;

    const parts = url.split('?');
    let result = {};

    if (parts.length > 1) {
        const query = parts[1];

        result = qs.parse(query);
    }

    return result;
};

export const deleteIrrelevantImgixKeys = (url: string): string | undefined => {
    if (!url) return;

    const parts = url.split('?');

    if (parts.length > 1) {
        const query = qs.parse(parts[1]);

        delete query.ixid;
        delete query.ixlib;
        delete query.q;
        delete query.w;

        return `${parts[0]}?${qs.stringify(query)}`;
    }

    return url;
};

export const getRatioBySize = ({
    height,
    width,
    size,
}: {
    height?: number;
    width?: number;
    size: ImageSize;
}): number | undefined => {
    if (size !== 'custom') {
        return sizeRatioMap[size];
    } else if (height && width) {
        const ratio = (height * 100) / width;

        return Math.min(ratio, maxImageRatio);
    }
};
